import { MODE_3D_VIEW } from '@constants'
import { useModularUiStore } from '@utils/modularSnap/modularUiStore'
import { useAppStore } from '@store'
import { useEffect } from 'react'

/**
 * Red de seguridad: resetea modo de arrastre colgado si pointerup no llega al mesh.
 * No toca la cámara ni itemDragActive — eso lo gestiona useMeshFloorDrag3D + CameraManager3D.
 */
export function ModularFloorDragSafety() {
  useEffect(() => {
    const releaseStuckGesture = () => {
      window.setTimeout(() => {
        const store = useAppStore.getState()
        if (store.mode !== 'MODE_DRAGGING_ITEM_3D' && store.mode !== 'MODE_DRAGGING_ITEM') {
          return
        }
        if (useModularUiStore.getState().itemDragActive) {
          return
        }
        store.setMode(MODE_3D_VIEW)
      }, 80)
    }

    window.addEventListener('pointerup', releaseStuckGesture)
    window.addEventListener('pointercancel', releaseStuckGesture)
    window.addEventListener('blur', releaseStuckGesture)

    return () => {
      window.removeEventListener('pointerup', releaseStuckGesture)
      window.removeEventListener('pointercancel', releaseStuckGesture)
      window.removeEventListener('blur', releaseStuckGesture)
    }
  }, [])

  return null
}
